var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBookOutline = function SvgBookOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "book-outline_svg__book_32dp",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".book-outline_svg__cls-2,.book-outline_svg__cls-4{fill:none}.book-outline_svg__cls-2{stroke:currentColor;stroke-width:1.5px}.book-outline_svg__cls-3{stroke:none}"))), /*#__PURE__*/React.createElement("path", {
    id: "book-outline_svg__frame",
    style: {
      fill: "transparent"
    },
    d: "M0 0h18v18H0z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "book-outline_svg__icon",
    transform: "translate(2.25 2.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "book-outline_svg__Rectangle_17888",
    "data-name": "Rectangle 17888",
    className: "book-outline_svg__cls-2",
    transform: "matrix(.998 -.07 .07 .998 8.201 1.933)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "book-outline_svg__cls-3",
    width: 4.522,
    height: 11.304,
    rx: 2.261
  }), /*#__PURE__*/React.createElement("rect", {
    className: "book-outline_svg__cls-4",
    x: 0.75,
    y: 0.75,
    width: 3.022,
    height: 9.804,
    rx: 1.511
  })), /*#__PURE__*/React.createElement("g", {
    id: "book-outline_svg__Rectangle_17885",
    "data-name": "Rectangle 17885",
    className: "book-outline_svg__cls-2",
    transform: "translate(4.07)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "book-outline_svg__cls-3",
    width: 4.522,
    height: 13.113,
    rx: 2.261
  }), /*#__PURE__*/React.createElement("rect", {
    className: "book-outline_svg__cls-4",
    x: 0.75,
    y: 0.75,
    width: 3.022,
    height: 11.613,
    rx: 1.511
  })), /*#__PURE__*/React.createElement("g", {
    id: "book-outline_svg__Rectangle_17887",
    "data-name": "Rectangle 17887",
    className: "book-outline_svg__cls-2",
    transform: "translate(0 4.07)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "book-outline_svg__cls-3",
    width: 4.522,
    height: 9.043,
    rx: 2.261
  }), /*#__PURE__*/React.createElement("rect", {
    className: "book-outline_svg__cls-4",
    x: 0.75,
    y: 0.75,
    width: 3.022,
    height: 7.543,
    rx: 1.511
  })))));
};

export default SvgBookOutline;